import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TabsConstants from "../../../constants";
import CommodityView from "./parts/Commodities/CommodityView";
import CommVarietyView from "./parts/CommodityVarietes/CommVarietyView";
import DestinationsList from "./parts/DestinationsList";
import FieldGroupView from "./parts/FieldGroups/FieldGroupView";

const styles = theme => ({
  root: {
    marginTop: 20
  },
  farmInfomationTabs: {
    border: "solid 1px #eee",
    marginTop: 10,
    padding: 0
  },
  bigIndicator: {
    height: 2,
    backgroundColor: "#00bc84"
  },
  activeTab: {
    color: "#00bc84 !important",
    fontWeight: "bold"
  },
  Tabs: {
    fontWeight: "bold"
  }
});

const CHILD_ROUTES = {
  FIELD_GROUPS: "field-groups",
  COMMODITIES: "commodities",
  COMMODITY_VARIETIES: "commodity-varieties",
  ONSITE_STORAGE: "onsite-storage"
};

class FarmInformationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || CHILD_ROUTES.FIELD_GROUPS,
      tabs: TabsConstants.FarmInformationChildren
    };
  }

  componentWillMount() {
    const path = window.location.pathname;
    if (
      path.includes(CHILD_ROUTES.FIELD_GROUPS) ||
      path === "/farmsetup/farminformation"
    ) {
      this.setState({ value: CHILD_ROUTES.FIELD_GROUPS });
    } else if (path.includes(CHILD_ROUTES.COMMODITIES)) {
      this.setState({ value: CHILD_ROUTES.COMMODITIES });
    } else if (path.includes(CHILD_ROUTES.COMMODITY_VARIETIES)) {
      this.setState({ value: CHILD_ROUTES.COMMODITY_VARIETIES });
    } else if (path.includes(CHILD_ROUTES.ONSITE_STORAGE)) {
      this.setState({ value: CHILD_ROUTES.ONSITE_STORAGE });
    }
  }

  onTabChange = (e, value) => {
    this.setState({
      value: value
    });
  };

  render() {
    const { classes } = this.props;
    const { value, tabs } = this.state;
    return (
      <div className={classes.root}>
        <Tabs
          className={classes.farmInfomationTabs}
          onChange={this.onTabChange}
          value={value}
          variant="scrollable"
          scrollButtons="off"
          classes={{ indicator: classes.bigIndicator }}
        >
          {tabs.map((tab, index) => (
            <Tab
              component={Link}
              to={tab.link}
              key={index}
              value={tab.value}
              label={tab.TabName}
              aria-label={tab.TabName}
              className={value === tab.value ? classes.activeTab : classes.Tabs}
            />
          ))}
        </Tabs>
        {value === CHILD_ROUTES.FIELD_GROUPS && <FieldGroupView />}
        {value === CHILD_ROUTES.COMMODITIES && <CommodityView />}
        {value === CHILD_ROUTES.COMMODITY_VARIETIES && <CommVarietyView />}
        {value === CHILD_ROUTES.ONSITE_STORAGE && <DestinationsList />}
      </div>
    );
  }
}

export default connect(null)(withStyles(styles)(FarmInformationView));



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/FarmInformationView.js